import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { getSelectedPromotions } from '../../../selectors/promotion'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { ReactComponent as SignalStrength } from '../../../assets/icons/signal-strength.svg'
import { ReactComponent as SignalStrengthMobile } from '../../../assets/icons/signal-strength.svg'
import styles from './DiscountsButton.module.scss'
import ConfirmModalV2 from '../../../components/ConfirmModalV2'
import useGetIsMobileScreen from '../../../hooks/useGetIsMobileScreen'
import { getNetworkAvailableValue } from '../../../utils/networkConnected'
import { Button } from '@material-ui/core'

const DiscountsButton = ({ selectedPaymentType, total }) => {
  const history = useHistory()
  const selectedPromotions = useSelector((state) => getSelectedPromotions(state))

  const [showNoInternetModal, setShowNoInternetModal] = useState(false)

  const isMobileViewPort = useGetIsMobileScreen()
  const networkAvailable = getNetworkAvailableValue()

  const buttonText = useMemo(() => {
    if (!selectedPromotions.length) return 'Add Discounts'
    return 'Modify Discounts'
  }, [selectedPromotions.length])

  const handleDiscountButtonClick = () => {
    if (!networkAvailable) {
      setShowNoInternetModal(true)
      return
    }

    history.push('/discounts', { selectedPaymentType, total })
  }

  return (
    <>
      <div className={styles.discountsButtonContainer}>
        <Button className={styles.discountsButton} onClick={handleDiscountButtonClick}>
          {buttonText}
        </Button>
      </div>
      {showNoInternetModal && (
        <ConfirmModalV2
          headerText={''}
          icon={isMobileViewPort ? <SignalStrengthMobile /> : <SignalStrength />}
          onButtonTwoClick={() => setShowNoInternetModal(false)}
          subtext={
            'Discounts are not supported while the device is offline. Please find a stable network connection to apply discounts'
          }
          singleButtonOnly={true}
          buttonTwoText={'OKAY'}
        />
      )}
    </>
  )
}

export default DiscountsButton
